export default __webpack_public_path__ + "static/media/remove-email.a4c610cf.svg";